import { useCallback } from "react";
import { useAuthenticatedRequestService } from "./service.base";
import { NamedHealthReport } from "../types/health-check.types";

export function useHealthService() {
  const { authGet } = useAuthenticatedRequestService();

  const getHealthStatus = useCallback(
    async function (): Promise<NamedHealthReport[] | null> {
      try {
        return await authGet("healthcheck/full");
      } catch (error) {
        console.error("Failed to fetch health status:", error);
        return null;
      }
    },
    [authGet]
  );

  return { getHealthStatus } as const;
}
